/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-07 17:30:11
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-04 11:05:35
 * @FilePath: /lobby/src/router/index.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import EnvelopeHome from '@/views/envelope/EnvelopeHome.vue'
import DepositViewForKE from '@/views/DepositViewForKE.vue'
import DepositViewForCI from '@/views/DepositViewForCI.vue'

console.log('meta.env.BASE_URL=', import.meta.env.BASE_URL)
console.log('isActive=', import.meta.env.VITE_IS_ACTIVE)
const isActive = import.meta.env.VITE_IS_ACTIVE == 'true'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: isActive ? EnvelopeHome : HomeView,
      meta: {
        title: isActive ? 'Envelope' : 'Home'
      }
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('../views/EventsView.vue'),
      meta: {
        title: 'Events'
      }
    },
    {
      path: '/depositke',
      name: 'depositke',
      component: DepositViewForKE, //() => import('../views/DepositViewForKE.vue'),
      meta: {
        title: 'Depositke'
      }
    },
    {
      path: '/depositci',
      name: 'depositci',
      component: DepositViewForCI, //() => import('../views/DepositViewForCI.vue'),
      meta: {
        title: 'Depositci'
      }
    },
    {
      path: '/deposittz',
      name: 'deposittz',
      component: () => import('../views/DepositViewForTZ.vue'),
      meta: {
        title: 'Deposittz'
      }
    },
    {
      path: '/depositgh',
      name: 'depositgh',
      component: () => import('../views/DepositViewForGH.vue'),
      meta: {
        title: 'Deposittz'
      }
    },
    {
      path: '/deposit',
      name: 'deposit',
      component: () => import('../views/DepositViewForET.vue'),
      meta: {
        title: 'Deposit'
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: () => import('../views/WithdrawView.vue'),
      meta: {
        title: 'Withdraw'
      }
    },
    {
      path: '/withdrawet',
      name: 'withdrawet',
      component: () => import('../views/WithdrawViewET.vue'),
      meta: {
        title: 'Withdraw'
      }
    },
    {
      path: '/withdrawtz',
      name: 'withdrawtz',
      component: () => import('../views/WithdrawViewTZ.vue'),
      meta: {
        title: 'Withdraw'
      }
    },
    {
      path: '/withdrawgh',
      name: 'withdrawgh',
      component: () => import('../views/WithdrawViewGH.vue'),
      meta: {
        title: 'Withdraw'
      }
    },
    {
      path: '/promotion',
      name: 'acting',
      component: () => import('../views/PromationView.vue'),
      meta: {
        title: 'promotion'
      }
    },
    {
      path: '/bonus',
      name: 'bonus',
      component: () => import('../views/Bonus.vue'),
      meta: {
        title: 'Bonus'
      }
    },
    {
      path: '/allgame/:categorie',
      name: 'allgame',
      component: () => import('../views/AllGame.vue'),
      meta: {
        title: 'AllGame'
      }
    },
    {
      path: '/gameView/:currentGameUrl',
      name: 'gameView',
      component: () => import('../views/GameView.vue'),
      meta: {
        title: 'GameView'
      }
    },
    {
      path: '/searchGame/:type',
      name: 'searchGame',
      component: () => import('../views/SearchGame.vue'),
      meta: {
        title: 'SearchGame'
      }
    },
    {
      path: '/tc',
      name: 'tc',
      component: () => import('../views/TC.vue'),
      meta: {
        title: 'TC'
      }
    },
    {
      path: '/bettinghistory',
      name: 'bettinghistory',
      component: () => import('../views/BettingHistory.vue'),
      meta: {
        title: 'BettingHistory'
      }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: () => import('../views/Transactions.vue'),
      meta: {
        title: 'Transactions'
      }
    },
    {
      path: '/bonusgames',
      name: 'bonusgames',
      component: () => import('../views/BonusGames.vue'),
      meta: {
        title: 'BonusGames'
      }
    },
    {
      path: '/rewardscenter',
      name: 'rewardscenter',
      component: () => import('../views/RewardCenter.vue'),
      meta: {
        title: 'RewardCenter'
      }
    },
    {
      path: '/firstRecharge',
      name: 'firstRecharge',
      component: () => import('../views/FirstRecharge.vue'),
      meta: {
        title: 'FirstRecharge'
      }
    },
    {
      path: '/cashback',
      name: 'cashback',
      component: () => import('../views/CashBack.vue'),
      meta: {
        title: 'CashBack'
      }
    },
    {
      path: '/howtodeposit',
      name: 'howtodeposit',
      component: () => import('../views/HowToDeposit.vue'),
      meta: {
        title: 'HowToDeposit'
      }
    },
    {
      path: '/howtowithdraw',
      name: 'howtowithdraw',
      component: () => import('../views/HowToWithdraw.vue'),
      meta: {
        title: 'HowToWithdraw'
      }
    },
    {
      path: '/ppgamepage',
      name: 'PPGamepage',
      component: () => import('../components/PPGamePage.vue'),
      meta: {
        title: 'PPGamepage'
      }
    },
    {
      path: '/luckycashback',
      name: 'luckyPig',
      component: () => import('../components/luckyPig.vue'),
      meta: {
        title: 'luckypig'
      }
    },
    {
      path: '/bonuswheel',
      name: 'BonusWheel',
      component: () => import('../components/BonusWheel.vue'),
      meta: {
        title: 'BonusWheel'
      }
    },
    {
      path: '/vpsexchange',
      name: 'VpsExchange',
      component: () => import('../components/VpsExchange.vue'),
      meta: {
        title: 'VpsExchange'
      }
    },
    {
      path: '/dailytask',
      name: 'DailyTask',
      component: () => import('../components/DailyTask.vue'),
      meta: {
        title: 'DailyTask'
      }
    },
    {
      path: '/million',
      name: 'Million',
      component: () => import('../components/Million.vue'),
      meta: {
        title: 'Million'
      }
    },
    {
      path: '/rushdeposit',
      name: 'RushDeposit',
      component: () => import('../views/RushDepositView.vue'),
      meta: {
        title: 'RushDeposit'
      }
    },
    {
      path: '/license',
      name: 'License',
      component: () => import('@/views/LicenseView.vue'),
      meta: {
        title: 'License'
      }
    }
  ]
})

export default router
